/** Chesta logo palette — shared brand colors */
export const LOGO_COLORS = {
  red: "#E50707",
  orange: "#E56105",
  yellow: "#E4E605",
  green: "#058D32",
  blue: "#0707E2",
  purple: "#8F05B7",
} as const;

export type LogoColorName = keyof typeof LOGO_COLORS;

/** Alias used across admin pages */
export const BRAND = LOGO_COLORS;

/**
 * Tailwind class fragments that reference logo hex values as full string
 * literals so JIT can detect them.
 */
export const LOGO_TW = {
  purpleBorder: "border-[#8F05B7]",
  purpleText: "text-[#8F05B7]",
  purpleBg: "bg-[#8F05B7]",
  purpleHoverSoft: "hover:bg-[#8F05B7]/10",
  purpleHoverDark: "hover:bg-[#7A049C]",
  redBg: "bg-[#E50707]",
  redHover: "hover:bg-[#c40606]",
  greenBg: "bg-[#058D32]",
  greenHover: "hover:bg-[#047028]",
} as const;

export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace("#", "");
  const n = parseInt(h, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
